export class PlanningJob {

  name = "";
  description = "";
  status= "";
  startDate : Date|null = null;
  endDate : Date|null = null;
  isActive = false;

  public static EMPTY = this.createEMPTY();

  static createEMPTY(){
    const job = new PlanningJob();
    job.name = "";
    job.isActive = false;
    return job;
  }

  public isEmpty(){
    return this.name === "";
  }

  public clone(): PlanningJob{
    const clone = new PlanningJob();
    clone.name = this.name;
    clone.description = this.description;
    clone.status = this.status;
    clone.startDate = this.startDate;
    clone.endDate = this.endDate;
    clone.isActive = this.isActive;
    return clone;
  }


}
